import styles from "./index.module.css";
import { generateAbbreviation } from "../../lib/util";

const ProductNoMediaCard = ({
  product,
  searchTerm,
  isMobile,
  showBorder = true,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        width: "100%",
        border: showBorder ? "1px solid #ccc" : "none",
        borderRadius: showBorder ? "1rem" : 0,
        overflow: "hidden",
      }}
      className={`${styles.productItemSkeleton} ${searchTerm && !isMobile ? styles.productItemSkeletonSearch : ""}`}
    >
      <div
        style={{
          height: "20rem",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f0f0f0",
          padding: "1rem",
          boxSizing: "border-box",
        }}
        aria-hidden
      >
        <div
          style={{
            fontSize: "3.5rem",
            color: "#444",
            textTransform: "uppercase",
            fontWeight: 700,
          }}
        >
          {generateAbbreviation(product.name || product.productId)}
        </div>
      </div>
    </div>
  );
};

export default ProductNoMediaCard;
